import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import htmlReactParser from 'html-react-parser';

import './B23-news-results.scss';

import FilterSelect from './components/filter-select';
import ViewMore from './components/view-more';

class B23NewsResults extends Component {
	constructor(props) {
		super(props);

		this.fetchResults = _.debounce(this.fetchResults.bind(this), 200);
		this.updateFilters = this.updateFilters.bind(this);
		this.renderResultItem = this.renderResultItem.bind(this);

		this.currentFilters = {};
		this.pageNumber = -1;

		this.state = {
			resultList: [],
			showViewMoreButton: false,
			waiting: false,
		};
	}

	componentDidMount() {
		this.fetchResults();
	}

	fetchResults() {
		const { data } = this.props;
		const { endpoint, endpointParams } = data;
		this.setState({ waiting: true });

		const postData = {
			...endpointParams,
			...this.currentFilters,
			pageNumber: this.pageNumber + 1,
		};

		fetch(endpoint, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(postData),
		}).then((response) => {
			return response.json();
		}).then((json) => {
			const { pageNumber, pageTotal, results } = json;
			const { resultList } = this.state;

			this.pageNumber = pageNumber;

			this.setState({
				resultList: resultList.concat(results),
				showViewMoreButton: pageNumber < pageTotal,
				waiting: false,
			});
		});
	}

	updateFilters(newFilter) {
		if (newFilter.value.length < 1) {
			delete this.currentFilters[newFilter.type];
		} else {
			this.currentFilters[newFilter.type] = newFilter.value;
		}

		this.setState({
			resultList: [],
		});

		this.pageNumber = -1;

		this.fetchResults();
	}

	renderResultItem(resultItem, index) {
		const { data } = this.props;
		const { readMoreText } = data;
		const { newsInfo } = resultItem;
		const keyName = newsInfo.type.split(' ').join('');

		return (
			<div className="B23-news-results__item" key={`${keyName}__${index}`}>
				<div className="B23-news-results__item__wrapper">
					<span className="B23-news-results__item__label">{newsInfo.type}</span>
					<h3 className="B23-news-results__item__title">{ htmlReactParser(newsInfo.title) }</h3>
					<span className="B23-news-results__item__date">{newsInfo.date}</span>
					<p className="B23-news-results__item__description">{ htmlReactParser(newsInfo.description) }</p>
					<a className="B23-news-results__item__cta btn btn--secondary" href={newsInfo.link}>
						{readMoreText}
						<span className="btn__arrow-angle" />
					</a>
				</div>
			</div>
		);
	}

	render() {
		const { data } = this.props;
		const { filterOptions, viewMoreText } = data;
		const { resultList, showViewMoreButton, waiting } = this.state;

		let fetchingElements = (
			<React.Fragment>
				{resultList.map(this.renderResultItem)}
				{showViewMoreButton ? <ViewMore text={viewMoreText} onClick={this.fetchResults} /> : null}
			</React.Fragment>
		);

		if (waiting) {
			fetchingElements = (
				<div className="B23-news-results__loading loading">
					<div className="loading__dots">Loading...</div>
				</div>
			)
		}

		return (
			<React.Fragment>
				<div className="container">
					<div className="B23-news-results__filters">
						<div className="B23-news-results__filters-row">
							{filterOptions.map((filter) => {
								return (
									<FilterSelect
										key={filter.id}
										filterType={filter.filterKey}
										filterName={filter.id}
										filterLabel={filter.label}
										filterOptions={filter.options}
										filterUpdate={this.updateFilters}
									/>
								);
							})}
						</div>
					</div>
				</div>
				<div className="container">
					{fetchingElements}
				</div>
			</React.Fragment>
		);
	}
}

B23NewsResults.defaultProps = {
	data: {},
};

B23NewsResults.propTypes = {
	data: PropTypes.shape({}),
};

export default B23NewsResults;
